import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RelatoriosService
{
  baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  buscarRelatorioAcessosPremocenter(dataInicio: string, dataFinal: string, clientes: string)
  {
    const url = `${this.baseUrl}relatorios/acessos-premocenter?dataInicio=${dataInicio}&dataFinal=${dataFinal}&clientes=${clientes}`;

    return this.http.get<any>(url);
  }
}
